import { type FC, type ReactNode } from "react";

import { AppTopBarList } from "@moment/design-system/AppTopBarList";

import { Header } from "~/components/canvas/navigation-pane/Header";
import { TopBar } from "~/components/topbar/TopBar";

/**
 * <CanvasTopBar/>
 * This is a shared topbar component for all of the canvas route views.
 */
export const CanvasTopBar: FC<{ children?: ReactNode }> = ({ children }) => {
	/* this component shares the same back button for the /canvasID route */
	return (
		<TopBar>
			<AppTopBarList grow>
				<Header />
			</AppTopBarList>
			<AppTopBarList>{children}</AppTopBarList>
		</TopBar>
	);
};
